__turbopack_context__.v({
  "resultsView": "styles-module-scss-module__3pQgxq__resultsView",
  "resultsViewContainer": "styles-module-scss-module__3pQgxq__resultsViewContainer",
  "resultsViewContainer__topRow": "styles-module-scss-module__3pQgxq__resultsViewContainer__topRow",
  "resultsViewContainer__topRow_greeting": "styles-module-scss-module__3pQgxq__resultsViewContainer__topRow_greeting",
  "resultsViewContainer__topRow_headline": "styles-module-scss-module__3pQgxq__resultsViewContainer__topRow_headline",
  "resultsViewContainer__topRow_hero": "styles-module-scss-module__3pQgxq__resultsViewContainer__topRow_hero",
  "resultsView__navbar": "styles-module-scss-module__3pQgxq__resultsView__navbar",
});
